import { DisclaimerContext } from 'hoc/DisclaimerContext.hoc';
import { useContext, useEffect } from 'react';

const DisclaimerPortal = props => {
  const disclaimerContext = useContext(DisclaimerContext);
  useEffect(() => {
    disclaimerContext?.addDisclaimer(props.name, props.children);
    return () => {
      disclaimerContext.removeDisclaimer(props.name);
    };
    //eslint-disable-next-line
  }, []);
  return <></>;
};

export default DisclaimerPortal;
